// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"6115acf6","379":"b2405fa7","533":"aaa55cde","787":"2b7c45ff"}[chunkId] + ".chunk.js";
};